import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { savePartnerLogo } from "../../actionCreators";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LogoComponent from "./LogoComponent";
import DescriptionIcon from "@mui/icons-material/Description";
import { Grid, Button } from "@mui/material";
import { CollapseCard } from "@totalsoft/rocket-ui";
import { useReactiveVar } from "@apollo/client";
import { synchronizationInProgressVar } from "variables";

const LogoContainer = ({ actions, partnerId, partner, partnerLoaded, setIsDirty, hasWritePermission }) => {
  const { t } = useTranslation();
  const synchronizationInProgress = useReactiveVar(synchronizationInProgressVar);
  const [localPartnerLogo, setPartnerLogo] = useState({ partnerId: partnerId, logoUrl: "" });
  const [cardExpanded, setExpanded] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);

  useEffect(() => {
    if (partnerLoaded) {
      setPartnerLogo({ partnerId: partnerId, logoUrl: partner.logoUrl });
    }
  }, [partnerLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const onExpand = expanded => {
    if (cardExpanded !== expanded) setExpanded(expanded);
  };

  const onPropertyChange = prop => value => {
    setPartnerLogo({
      ...localPartnerLogo,
      [prop]: value
    });

    setSaveDisabled(false);
    setIsDirty(true);
  };

  const savePartnerLogo = (partnerId, localPartnerLogo) => {
    if (!hasWritePermission) return;
    actions.savePartnerLogo(partnerId, localPartnerLogo, () => {
      setIsDirty(false);
      setSaveDisabled(true);
    });
  };

  return (
    <CollapseCard
      id="logoPartnerCard"
      icon={DescriptionIcon}
      iconColor="primary"
      title={t("Logo.Title")}
      expanded={cardExpanded}
      onToggle={(_, expanded) => onExpand(!expanded)}
      defaultExpanded={synchronizationInProgress}
      toggleOnHeaderClick
    >
      {localPartnerLogo ? (
        <Grid container spacing={2}>
          <LogoComponent
            onPropertyChange={onPropertyChange}
            setSaveDisabled={setSaveDisabled}
            partnerLogo={localPartnerLogo}
            hasWritePermission={hasWritePermission}
          />
          <Grid item xs={12} sm={12} md={12}>
            <Button
              id="logo_saveBtn"
              color="primary"
              variant="contained"
              onClick={() => savePartnerLogo(partnerId, localPartnerLogo)}
              disabled={!hasWritePermission || saveDisabled}
            >
              {t("Save")}
            </Button>
          </Grid>
        </Grid>
      ) : (
        <span>{""}</span>
      )}
    </CollapseCard>
  );
};

LogoContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  partnerId: PropTypes.number,
  partner: PropTypes.object,
  setIsDirty: PropTypes.func,
  partnerLoaded: PropTypes.bool,
  hasWritePermission: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        savePartnerLogo
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(null, mapDispatchToProps)(LogoContainer);
